module.exports = __webpack_public_path__ + "img/world_wide_web.0e144477.svg";